import { createColumnHelper } from '@tanstack/react-table';
import { DateTime } from 'luxon';

import { ViewOnTilledCell } from '../../invoices/management/cells/ViewOnTilledCell';
import { InvoiceNumberCell } from '../../payments/cells/InvoiceNumberCell';
import type { TilledPayoutReadOnlyRead } from 'src/common/external/bambi-api/bambiApi';
import { formatPriceCell } from 'src/common/formatPriceCell';

const columnHelper = createColumnHelper<TilledPayoutReadOnlyRead>();

export const columns = [
  columnHelper.accessor('invoices', {
    header: 'Invoice(s)',
    cell({ getValue }) {
      const invoices = getValue();
      if (!invoices.length) {
        return <>&mdash;</>;
      }

      return (
        <div className="flex w-[100px] flex-col justify-start">
          {invoices.map((invoice) => (
            <InvoiceNumberCell
              key={invoice.id}
              invoiceNumber={invoice.number}
              invoiceId={invoice.id}
            />
          ))}
        </div>
      );
    },
    meta: {
      headerWidth: 100,
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('amount', {
    header: 'Amount',
    cell({ row }) {
      return formatPriceCell(row.original.amount);
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('paid_at', {
    header: 'Paid at',
    cell({ getValue }) {
      const value = getValue();
      if (!value) {
        return '-';
      }

      return DateTime.fromISO(value).toFormat('MM/dd/yyyy');
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('description', {
    header: 'Description',
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('failure_code', {
    header: 'Failure Code (if failed)',
    cell({ getValue }) {
      const value = getValue();
      if (!value) {
        return '-';
      }
      return value;
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.display({
    header: 'Manage',
    cell({ row: { original } }) {
      return (
        <ViewOnTilledCell type="payouts" resourceId={original.payout_id} />
      );
    },
    meta: {
      enableHeaderMenu: false,
      headerWidth: 80,
    },
  }),
];
